import React, { useState, useEffect } from "react";
import LeftSideNavigation from "../../../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import HomeReusableTopBarNavigation from "../../../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import { useHistory } from "react-router-dom";
import { Col, Row } from "react-bootstrap";
import { BackLogoIconButton } from "../../../../../reusableComponents/smallReusableComponent/LoginTopLogoAndText";
import { TopTextReusableComponent } from "../../../../../vendorOnboradingComponents/reusableOnboardingComponent/TopTextReusable/TopTextReusableComponent";
import {
  ReusableOnboardingButton,
  ReusableOnboardingLink,
} from "../../../../../vendorOnboradingComponents/reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
// import Switch from "react-switch";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import {
  NewInputText,
  SelectBoxMUiInputComponent,
} from "../../../../../reusableComponents/inputReusableComponent/InputBoxComponent";
import { FormControl, Select, InputLabel, MenuItem } from "@material-ui/core";
import { ToggleButtonWithYesNo } from "../../../AllButton/ToggleButtonReuse";
import InputNumberFunc from "../../../../../../function/InputNumberFunc";
import { useFormik } from "formik";
import * as yup from "yup";
import Alert from "react-s-alert";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { admin_update_new_subscription_for_vendor } from "../../../../../../store/actions/SuperAdminActions/adminNewVendorOnboard";
import { AmealioLoader } from "../../../../../Loader/AmealioLoader";
import { SliderReusableComponent } from "../../../../../reusableComponents/sliderReusableComponent/SliderReusableComponent";
import isEmpty from "../../../../../../store/validation/is-Empty";
import { MobileTopHeader } from "../../../../../reusableComponents/sliderReusableComponent/MobileTopHeader";
import Media from "react-media";

const validationSchema = yup.object({
  distance: yup.number().required("distance is required"),
  request_period: yup.number().required("request period is required"),
  min_person: yup.number().required("minimum person is required"),
  table_kept_time: yup.number().required("table kept time is required"),
  // auto_min_person: yup.number().required("minimum person is required"),
  auto_cancel: yup.number().required("auto cancel is required"),
});

export const WalkinWaitlistScreen = (props) => {
  const [disabled, setDisabled] = useState(props.location?.state?.access);
  let history = useHistory();
  const [state, setState] = useState({
    casualSeatingAutoAccept: true,
  });

  const validate = () => {
    const errors = {};
    if (formik.values.min_person === 0) {
      errors.min_person = "at least 1 mimimum person is required";
    }
    // if (formik.values.auto_min_person === 0) {
    //   errors.auto_min_person = "at least 1 mimimum person is required";
    // }
    return errors;
  };

  const casualSeatingAutoAcceptHandler = (e) => {
    setState({
      ...state,
      casualSeatingAutoAccept: !state.casualSeatingAutoAccept,
    });
  };

  const formik = useFormik({
    initialValues: {
      distance: 10000,
      request_period: 30,
      min_person: 1,
      table_kept_time: 15,
      auto_min_person: "",
      auto_cancel: 15,
      auto_cancel_open_restaurant: 1,
      auto_cancel_close_restaurant: 5,
    },
    validationSchema,
    validate,

    onSubmit: (values) => {
      let valuesData = {
        // value:
        //   values.distance === "" &&
        //   values.request_period === "" &&
        //   values.min_person === "" &&
        //   values.table_kept_time === "" &&
        //   state.casualSeatingAutoAccept === false &&
        //   values.auto_min_person === ""
        //     ? false
        //     : true,
        // walkin_waitlist: {
        value:
          values.distance === "" &&
            values.request_period === "" &&
            values.min_person === "" &&
            values.table_kept_time === "" &&
            state.casualSeatingAutoAccept === true &&
            values.auto_min_person === ""
            ? false
            : true,
        distance: values.distance,
        request_period: values.request_period,
        min_person: values.min_person,
        table_kept_time: values.table_kept_time,
        auto_accept: {
          value: state.casualSeatingAutoAccept,
          min_person: values.auto_min_person,
        },
        auto_cancel: values.auto_cancel,
        auto_cancel_open_restaurant: values.auto_cancel_open_restaurant,
        auto_cancel_close_restaurant: values.auto_cancel_close_restaurant,
        // },
      };

      const token = props?.auth?.user?.accessToken;
      const subscriptionId = props?.subscription?._id;
      let formData = props?.allSubscriptionsData;
      formData.casual_dining_status.seating.walkin_waitlist = valuesData;
      props.admin_update_new_subscription_for_vendor(
        subscriptionId,
        formData,
        token,
        onSuccess
      );
    },
  });

  const onSuccess = (e) => {
    Alert.success("<h4>Walkin Waitlist changes add successfully</h4>", {
      position: "top-right",
      effect: "bouncyflip",
      beep: true,
      html: true,
      timeout: 3000,
      offset: 35,
    });
    history.push("/admin-casual-dining/seatingmanagement");
  };

  const [count, setCount] = useState(1);
  const onClickSave = () => {
    setCount(count + 1);
    formik.handleSubmit();
  };

  const maxLengthCheck = (object) => {
    if (object.target.value.length > object.target.maxLength) {
      object.target.value = object.target.value.slice(
        0,
        object.target.maxLength
      );
    }
  };

  useEffect(() => {
    if (formik.errors && formik.errors.distance) {
      let distanceElement = document.getElementById("distance");
      distanceElement.focus();
    } else if (formik.errors && formik.errors.request_period) {
      let request_periodElement = document.getElementById("request_period");
      request_periodElement.focus();
    } else if (formik.errors && formik.errors.min_person) {
      let min_personElement = document.getElementById("min_person");
      min_personElement.focus();
    } else if (formik.errors && formik.errors.table_kept_time) {
      let table_kept_timeElement = document.getElementById("table_kept_time");
      table_kept_timeElement.focus();
    }
    //  else if (formik.errors && formik.errors.auto_min_person) {
    //   let auto_min_personElement = document.getElementById("auto_min_person");
    //   auto_min_personElement.focus();
    // }
    else if (formik.errors && formik.errors.auto_cancel) {
      let auto_cancelElement = document.getElementById("auto_cancel");
      auto_cancelElement.focus();
    }
  }, [count]);

  useEffect(() => {
    const walkinWaitlist = {
      ...(props?.subscriptionData && props?.subscriptionData),
    };
    if (walkinWaitlist?.distance) {
      formik.setFieldValue("distance", walkinWaitlist?.distance);
    }
    if (walkinWaitlist?.request_period) {
      formik.setFieldValue("request_period", walkinWaitlist?.request_period);
    }
    if (walkinWaitlist?.min_person) {
      formik.setFieldValue("min_person", walkinWaitlist?.min_person);
    }
    if (walkinWaitlist?.table_kept_time) {
      formik.setFieldValue("table_kept_time", walkinWaitlist?.table_kept_time);
    }
    if (
      walkinWaitlist?.auto_accept &&
      walkinWaitlist?.auto_accept?.min_person
    ) {
      formik.setFieldValue(
        "auto_min_person",
        walkinWaitlist?.auto_accept && walkinWaitlist?.auto_accept?.min_person
      );
    }
    if (walkinWaitlist && walkinWaitlist?.auto_cancel) {
      formik.setFieldValue(
        "auto_cancel",
        walkinWaitlist && walkinWaitlist?.auto_cancel
      );
    }
    if (walkinWaitlist && walkinWaitlist?.auto_cancel_open_restaurant) {
      formik.setFieldValue(
        "auto_cancel_open_restaurant",
        walkinWaitlist && walkinWaitlist?.auto_cancel_open_restaurant
      );
    }
    if (walkinWaitlist && walkinWaitlist?.auto_cancel_close_restaurant) {
      formik.setFieldValue(
        "auto_cancel_close_restaurant",
        walkinWaitlist && walkinWaitlist?.auto_cancel_close_restaurant
      );
    }
    setState({
      ...state,
      casualSeatingAutoAccept: !isEmpty(
        walkinWaitlist?.auto_accept && walkinWaitlist?.auto_accept?.value
      )
        ? walkinWaitlist?.auto_accept && walkinWaitlist?.auto_accept?.value
        : true,
    });
  }, [props?.subscriptionData]);

  if (props?.auth.loader === true) {
    return (
      <React.Fragment>
        <AmealioLoader />
      </React.Fragment>
    );
  } else {
    return (
      <React.Fragment>
        <div className="container-fluid">
          <div className="row">
            <div className="left-side-panel">
              <LeftSideNavigation displayLink={1} />
            </div>
            <div className="super-admin-right-side-panel">
              <HomeReusableTopBarNavigation />
              <div
                // id="onboarding-scrollbar"
                className="col-12 new-subscription-onboarding-component pt-4"
              >
                {/* <Media query="(min-width: 991px)">
                <div className="col-12">
                  <BackLogoIconButton
                    displayBackText={true}
                    displayArrow={true}
                    backButtonClicked={"/admin-casual-dining/seatingmanagement"}
                    notDisplaProgressBar={true}
                  />
                </div>
              </Media> */}
                <Media query="(max-width: 991px)">
                  <MobileTopHeader
                    link={true}
                    onLink={"/admin-casual-dining/seatingmanagement"}
                  />
                </Media>

                <div className="col-8 onboarding_process_screen-button-map inside-subscription-event-section inside-subscription-event-section-mobile-walkinwaitlist">
                  <div>
                    <TopTextReusableComponent headingText="Walk-in / Waitlist Settings" />
                  </div>
                  <div className="inside-event-offline-online-text">
                    <div className="row margin-between-toggler mt-4">
                      <div className="col-6">
                        <h4 className="f14-700">*Distance</h4>
                        <p className="f11-400 opacity5">
                          (Max Distance of user location from which they can
                          make Walk-in / Wait request)
                        </p>
                      </div>
                      <div className="col-3">
                        <FormControl
                          variant="outlined"
                          className={"w-100"}
                          disabled={disabled}
                        >
                          {/* <InputLabel htmlFor="outlined-Minutes">
                          Kilometers
                        </InputLabel> */}
                          <Select
                            // label="Kilometers"
                            name="distance"
                            id="distance"
                            disabled={disabled}
                            className={`w-100 ${formik.errors.distance && formik.touched.distance
                                ? "enError outlined-Minutes"
                                : "outlined-Minutes"
                              }`}
                            onChange={formik.handleChange}
                            value={formik.values.distance}
                            onBlur={formik.handleBlur}
                            isInvalid={
                              formik.errors.distance && formik.touched.distance
                            }
                            // className="outlined-Minutes"
                            IconComponent={KeyboardArrowDownIcon}
                          >
                            <MenuItem value={10000}>No Limit</MenuItem>
                            <MenuItem value={50}>50</MenuItem>
                            <MenuItem value={30}>30</MenuItem>
                            <MenuItem value={20}>20</MenuItem>
                            <MenuItem value={1}>1</MenuItem>
                          </Select>
                          {formik.errors.distance && formik.touched.distance ? (
                            <div className="pho_14_regular text-danger">
                              {formik.errors.distance}
                            </div>
                          ) : null}
                        </FormControl>
                      </div>
                      <div className="col-3 f12-500 m-auto">Kilometers</div>
                    </div>
                    <div className="row margin-between-toggler">
                      <div className="col-6">
                        <h4 className="f14-700">*Request Period</h4>
                        <p className="f11-400 opacity5">
                          (Minimum period before arrival user can make a
                          request, shown as message at the time Of request
                          creation to the user)
                        </p>
                      </div>
                      <div className="col-3">
                        <FormControl
                          variant="outlined"
                          className={"w-100"}
                          disabled={disabled}
                        >
                          {/* <InputLabel htmlFor="outlined-Minutes">
                          Minutes
                        </InputLabel> */}
                          <Select
                            // label="Minute"
                            name="request_period"
                            id="request_period"
                            disabled={disabled}
                            className={`w-100 ${formik.errors.request_period &&
                                formik.touched.request_period
                                ? "enError outlined-Minutes"
                                : "outlined-Minutes"
                              }`}
                            onChange={formik.handleChange}
                            value={formik.values.request_period}
                            onBlur={formik.handleBlur}
                            isInvalid={
                              formik.errors.request_period &&
                              formik.touched.request_period
                            }
                            // className="outlined-Minutes"
                            IconComponent={KeyboardArrowDownIcon}
                          >
                            <MenuItem value={10}>10</MenuItem>
                            <MenuItem value={20}>20</MenuItem>
                            <MenuItem value={30}>30</MenuItem>
                            <MenuItem value={45}>45</MenuItem>
                            <MenuItem value={60}>60</MenuItem>
                          </Select>
                          {formik.errors.request_period &&
                            formik.touched.request_period ? (
                            <div className="pho_14_regular text-danger">
                              {formik.errors.request_period}
                            </div>
                          ) : null}
                        </FormControl>
                      </div>
                      <div className="col-3 f12-500 m-auto">Minutes</div>
                    </div>
                    <div className="row margin-between-toggler">
                      <div className="col-6">
                        <h4 className="f14-700">*Minimum Person</h4>
                      </div>
                      <div className="col-3">
                        <NewInputText
                          extraClass="mb-1"
                          disabled={disabled}
                          name="min_person"
                          inputType="number"
                          onInput={maxLengthCheck}
                          maxLength={5}
                          //onKeyDown={InputNumberFunc}
                          onKeyPress={(event) => {
                            if (!/[0-9]/.test(event.key)) {
                              event.preventDefault();
                            }
                          }}
                          onFocusOut={formik.handleBlur}
                          onChange={formik.handleChange}
                          value={formik.values.min_person}
                          // labelText="Pax"
                          controlClass="min_person"
                        />
                        {formik.errors.min_person &&
                          formik.touched.min_person ? (
                          <div className="pho_14_regular text-danger">
                            {formik.errors.min_person}
                          </div>
                        ) : null}
                      </div>
                      <div className="col-3 f12-500 m-auto">PAX</div>
                    </div>
                    <div className="row margin-between-toggler">
                      <div className="col-6 col-md-6 col-lg-6">
                        <h4 className="f14-700">*Table Is kept for</h4>
                        <p className="f11-400 opacity5">
                          (Table is kept for stipulated time and cancelled)
                        </p>
                      </div>
                      <div className="col-3 col-md-3 col-lg-3">
                        <FormControl
                          variant="outlined"
                          className={"w-100"}
                          disabled={disabled}
                        >
                          {/* <InputLabel htmlFor="outlined-Minutes">
                          Minutes
                        </InputLabel> */}
                          <Select
                            // label="Minute"
                            name="table_kept_time"
                            id="table_kept_time"
                            disabled={disabled}
                            className={`w-100 ${formik.errors.table_kept_time &&
                                formik.touched.table_kept_time
                                ? "enError outlined-Minutes"
                                : "outlined-Minutes"
                              }`}
                            onChange={formik.handleChange}
                            value={formik.values.table_kept_time}
                            onBlur={formik.handleBlur}
                            isInvalid={
                              formik.errors.table_kept_time &&
                              formik.touched.table_kept_time
                            }
                            // className="outlined-Minutes"
                            IconComponent={KeyboardArrowDownIcon}
                          >
                            <MenuItem value={0}>00</MenuItem>
                            <MenuItem value={5}>05</MenuItem>
                            <MenuItem value={10}>10</MenuItem>
                            <MenuItem value={15}>15</MenuItem>
                            <MenuItem value={20}>20</MenuItem>
                            <MenuItem value={30}>30</MenuItem>
                            <MenuItem value={45}>45</MenuItem>
                            <MenuItem value={60}>60</MenuItem>
                          </Select>
                          {formik.errors.table_kept_time &&
                            formik.touched.table_kept_time ? (
                            <div className="pho_14_regular text-danger">
                              {formik.errors.table_kept_time}
                            </div>
                          ) : null}
                        </FormControl>
                      </div>
                      <div className="col-3 f12-500 m-auto">Minutes</div>
                    </div>
                    <div className="row margin-between-toggler">
                      <div className="col-6 col-md-6 col-lg-6">
                        <h4 className="f16-700">Auto Accept</h4>
                      </div>
                      <div className="col-3 col-md-3 col-lg-3 d-flex">
                        <ToggleButtonWithYesNo
                          disabled={disabled}
                          activeClass={state.casualSeatingAutoAccept}
                          checkedBox={state.casualSeatingAutoAccept}
                          onChange={casualSeatingAutoAcceptHandler}
                        />
                      </div>
                    </div>
                    {state.casualSeatingAutoAccept ? (
                      <div className="row margin-between-toggler mt-4">
                        <div className="col-6 col-md-6 col-lg-6">
                          <h4 className="f14-700">Maximum Person</h4>
                        </div>
                        <div className="col-3 col-md-3 col-lg-3">
                          <NewInputText
                            extraClass="mb-1"
                            name="auto_min_person"
                            disabled={disabled}
                            onInput={maxLengthCheck}
                            maxLength={5}
                            //onKeyDown={InputNumberFunc}
                            onKeyPress={(event) => {
                              if (!/[0-9]/.test(event.key)) {
                                event.preventDefault();
                              }
                            }}
                            inputType="number"
                            onFocusOut={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.auto_min_person}
                            // labelText="Pax"
                            controlClass="auto_min_person"
                          />
                          {/* {formik.errors.auto_min_person &&
                        formik.touched.auto_min_person ? (
                          <div className="pho_14_regular text-danger">
                            {formik.errors.auto_min_person}
                          </div>
                        ) : null} */}
                        </div>
                        <div className="col-3 f12-500 m-auto">Pax</div>
                      </div>
                    ) : null}
                    {/* <div className="row mb-3">
                    <div className=" col-6 col-md-6 col-lg-6">
                      <div className="f14-700">Auto Cancel</div>
                      <div className="f11-400 opacity5">
                        Pending Orders have to be accepted within Specified
                        period Otherwise it will be cancelled
                      </div>
                    </div>
                    <div className="col-3 col-md-3 col-lg-3">
                      <Row>
                        <Col md={12}>
                          <FormControl
                            variant="outlined"
                            className={"w-100"}
                            disabled={disabled}
                          >
                            {/* <InputLabel htmlFor="outlined-Minutes">
                              Minutes
                            </InputLabel> *
                            <Select
                              // label="Minute"
                              name="auto_cancel"
                              disabled={disabled}
                              id="auto_cancel"
                              className={`w-100 ${
                                formik.errors.auto_cancel &&
                                formik.touched.auto_cancel
                                  ? "enError outlined-Minutes"
                                  : "outlined-Minutes"
                              }`}
                              onChange={formik.handleChange}
                              value={formik.values.auto_cancel}
                              onBlur={formik.handleBlur}
                              isInvalid={
                                formik.errors.auto_cancel &&
                                formik.touched.auto_cancel
                              }
                              // className="outlined-Minutes"
                              IconComponent={KeyboardArrowDownIcon}
                            >
                              <MenuItem value={5}>5</MenuItem>
                              <MenuItem value={10}>10</MenuItem>
                              <MenuItem value={15}>15</MenuItem>
                            </Select>
                            {formik.errors.auto_cancel &&
                            formik.touched.auto_cancel ? (
                              <div className="pho_14_regular text-danger">
                                {formik.errors.auto_cancel}
                              </div>
                            ) : null}
                          </FormControl>
                        </Col>
                      </Row>
                    </div>
                    <div className="col-3 f12-500 m-auto">Minutes</div>
                  </div> */}
                    <div className="row mb-3">
                      <div className=" col-6 col-md-6 col-lg-6">
                        <div className="f14-700">
                          Auto Cancel&nbsp;
                          <i
                            className="fa fa-info-circle"
                            style={{ color: "#9E9E9E" }}
                            aria-hidden="true"
                          ></i>
                        </div>
                        <div className="f11-400 opacity5">
                          (Acceptance period for pending requests when
                          restaurant is open)
                        </div>
                      </div>
                      <div className="col-3 col-md-3 col-lg-3">
                        <Row>
                          <Col md={12}>
                            <FormControl
                              variant="outlined"
                              className={"w-100"}
                              disabled={true}
                            >
                              <NewInputText
                                extraClass="mb-1"
                                name="auto_cancel_open_restaurant"
                                disabled={true}
                                onInput={maxLengthCheck}
                                maxLength={5}
                                onKeyPress={(event) => {
                                  if (!/[0-9]/.test(event.key)) {
                                    event.preventDefault();
                                  }
                                }}
                                inputType="number"
                                onFocusOut={formik.handleBlur}
                                onChange={formik.handleChange}
                                value={
                                  formik.values.auto_cancel_open_restaurant
                                }
                                // labelText="Minutes"
                                controlClass="auto_cancel_open_restaurant"
                              />
                            </FormControl>
                          </Col>
                        </Row>
                      </div>
                      <div className="col-3 f12-500 m-auto">Minutes</div>
                    </div>
                    <div className="row mb-3">
                      <div className=" col-6 col-md-6 col-lg-6">
                        <div className="f14-700">
                          Auto Cancel&nbsp;
                          <i
                            className="fa fa-info-circle"
                            style={{ color: "#9E9E9E" }}
                            aria-hidden="true"
                          ></i>
                        </div>
                        <div className="f11-400 opacity5">
                          (Acceptance period for pending requests when
                          restaurant is close)
                        </div>
                      </div>
                      <div className="col-3 col-md-3 col-lg-3">
                        <Row>
                          <Col md={12}>
                            <FormControl
                              variant="outlined"
                              className={"w-100"}
                              disabled={disabled}
                            >
                              <NewInputText
                                extraClass="mb-1"
                                name="auto_cancel_close_restaurant"
                                disabled={true}
                                onInput={maxLengthCheck}
                                maxLength={5}
                                onKeyPress={(event) => {
                                  if (!/[0-9]/.test(event.key)) {
                                    event.preventDefault();
                                  }
                                }}
                                inputType="number"
                                onFocusOut={formik.handleBlur}
                                onChange={formik.handleChange}
                                value={
                                  formik.values.auto_cancel_close_restaurant
                                }
                                // labelText="Minutes"
                                controlClass="auto_cancel_close_restaurant"
                              />
                            </FormControl>
                          </Col>
                        </Row>
                      </div>
                      <div className="col-3 f12-500 m-auto">Minutes</div>
                    </div>
                  </div>
                  <div className="onboarding-map-setup-screen-autodetect-button ">
                    <ReusableOnboardingLink
                      buttonTitle="Back Button"
                      buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
                      buttonText="Back"
                      link="/admin-casual-dining/seatingmanagement"
                    />
                    {!disabled && (
                      <ReusableOnboardingButton
                        buttonTitle="Done Button"
                        buttonClass={
                          state.casualSeatingAutoAccept === true &&
                            formik.values.auto_min_person === ""
                            ? "onboarding_button_link_reusable onboarding_button_link_reusable_white ml-3"
                            : "onboarding_button_link_reusable onboarding_button_link_reusable_red ml-3"
                        }
                        buttonText="Done"
                        buttonType="button"
                        onClick={
                          state.casualSeatingAutoAccept === true &&
                            formik.values.auto_min_person === ""
                            ? () => console.log()
                            : () => onClickSave()
                        }
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
};

WalkinWaitlistScreen.propTypes = {
  auth: PropTypes.object.isRequired,
  admin_update_new_subscription_for_vendor: PropTypes.func.isRequired,
  subscription: PropTypes.object.isRequired,
  subscriptionData: PropTypes.object.isRequired,
  allSubscriptionsData: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state?.auth,
  subscription:
    state?.superAdminOnboarding &&
    state?.superAdminOnboarding?.onboard_subscription_details,
  subscriptionData:
    state?.superAdminOnboarding &&
    state?.superAdminOnboarding?.onboard_subscription_details &&
    state?.superAdminOnboarding?.onboard_subscription_details
      ?.casual_dining_status &&
    state?.superAdminOnboarding?.onboard_subscription_details
      ?.casual_dining_status?.seating &&
    state?.superAdminOnboarding?.onboard_subscription_details
      ?.casual_dining_status?.seating?.walkin_waitlist,
  allSubscriptionsData:
    state?.superAdminOnboarding &&
    state?.superAdminOnboarding?.onboard_subscription_details,
});

export default connect(mapStateToProps, {
  admin_update_new_subscription_for_vendor,
})(withRouter(WalkinWaitlistScreen));
